import { render, staticRenderFns } from "./bookDiscrepancies.vue?vue&type=template&id=24985fec&"
import script from "./bookDiscrepancies.vue?vue&type=script&lang=js&"
export * from "./bookDiscrepancies.vue?vue&type=script&lang=js&"
import style0 from "./bookDiscrepancies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports